var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F5FDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8333 26.4999C35.8333 25.9028 35.6055 25.3057 35.1499 24.8501C34.6943 24.3945 34.0972 24.1667 33.5 24.1667M33.5 33.5C37.366 33.5 40.5 30.366 40.5 26.5C40.5 22.634 37.366 19.5 33.5 19.5C29.634 19.5 26.5 22.634 26.5 26.5C26.5 26.8193 26.5214 27.1336 26.5628 27.4415C26.6309 27.948 26.6649 28.2013 26.642 28.3615C26.6181 28.5284 26.5877 28.6184 26.5055 28.7655C26.4265 28.9068 26.2873 29.046 26.009 29.3243L20.0467 35.2866C19.845 35.4884 19.7441 35.5893 19.6719 35.707C19.608 35.8114 19.5608 35.9252 19.5322 36.0442C19.5 36.1785 19.5 36.3212 19.5 36.6065V38.6333C19.5 39.2867 19.5 39.6134 19.6272 39.863C19.739 40.0825 19.9175 40.261 20.137 40.3728C20.3866 40.5 20.7133 40.5 21.3667 40.5H24.1667V38.1667H26.5V35.8333H28.8333L30.6757 33.991C30.954 33.7127 31.0932 33.5735 31.2345 33.4945C31.3816 33.4123 31.4716 33.3819 31.6385 33.358C31.7987 33.3351 32.052 33.3691 32.5585 33.4372C32.8664 33.4786 33.1807 33.5 33.5 33.5Z",
    stroke: "#007AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#007AFF",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.5fa3a6f0659159f996f7dc5ff8232651.svg";
export { ForwardRef as ReactComponent };